<template lang="pug">
.addUnit__deviceInfo
  van-nav-bar(
    :title="$t('new3.unit.integration')"
    left-arrow
    @click-left="close")

  .main.addUnit__integrations
    van-cell-group.addUnit__popup__cell-group
      van-cell.van-cell--value-select(
        v-if='device.rs485_mode !== undefined',
        title="RS-485"
        :value="output"
        @click="openSetOutput(output)"
        is-link)

      //- Modbus
      van-cell-group.home__title.protocol__modbus__bacnet(v-if="device.rs485_mode === 0 && device.bacneton === false")
        van-field(
          type="number"
          v-if="device.modbusaddr !== undefined"
          v-model="modbusaddr"
          @change="saveProtocol"
          :label="$t('protocol.modbusaddr')"
          :error-message="modbusaddrError")
        van-cell.van-cell--value-select(
          v-if="device.modbusspeed !== undefined"
          size="large"
          :title="$t('protocol.modbusspeed')"
          :value="modbusspeed"
          @click="openSetSpeed(modbusspeed, 'modbus')")

      //- Bacnet
      van-cell-group.home__title.protocol__modbus__bacnet(v-if="device.rs485_mode === 1 && device.bacneton === true")
        van-field(
          type="number"
          v-if="device.bacnetmac !== undefined"
          v-model="bacnetmac"
          @change="saveProtocol"
          :label="$t('protocol.bacnetmac')"
          :error-message="bacnetmacError")
        van-field(
          type="number"
          v-if="device.bacnetid !== undefined"
          v-model="bacnetid"
          @change="saveProtocol"
          :label="$t('protocol.bacnetid')"
          :error-message="bacnetidError")
        van-cell.van-cell--value-select(
          v-if="device.bacnetspeed !== undefined"
          :title="$t('protocol.bacnetspeed')"
          :value="bacnetspeed"
          @click="openSetSpeed(bacnetspeed, 'bacnet')")
        van-field(
          type="number"
          v-if="device.bacnetmaxnum !== undefined"
          v-model="bacnetmaxnum"
          @change="saveProtocol"
          :label="$t('protocol.bacnetmaxnum')"
          :error-message="bacnetmaxnumError")
        van-field(
          type="number"
          v-if="device.bacnetmaxframes !== undefined"
          v-model="bacnetmaxframes"
          @change="saveProtocol"
          :label="$t('protocol.bacnetmaxframes')"
          :error-message="bacnetmaxframesError")

      van-switch-cell(
        v-if='device.lapi !== undefined',
        v-model='lapi',
        :title='$t("new3.unit.lapi")',
        @change="saveWsService('lapi', lapi)"
      )

      van-switch-cell(
        v-if='device.venstar !== undefined',
        v-model='venstar',
        :title='$t("new3.unit.venstar")',
        @change="saveWsService('venstar', venstar)"
      )

      van-switch-cell(
        v-if='device.ecobeesb !== undefined',
        v-model='ecobeesb',
        :title='$t("new3.unit.ecobeeSB")',
        @change="setEcobeeSB(ecobeesb)"
      )

      van-cell-group.addUnit__popup__cell-group.home__title(
        v-if="ecobeesb"
      )

        van-field(
          v-model="device.ecobeesbclientid"
          border=false
          input-align="right"
          :label="$t('new3.unit.clientID')"
          :placeholder="$t('new3.unit.clientID')"
          :error-message="ecobeesbclientidError"
          @keyup="setButtonEcobeeSB")

        van-field(
          border=false
          input-align="right"
          v-model="device.ecobeesbclientsecret"
          :label="$t('new3.unit.clientSecret')"
          :placeholder="$t('new3.unit.clientSecret')"
          :error-message="ecobeesbclientsecretError"
          @keyup="setButtonEcobeeSB")

        van-field(
          border=false
          input-align="right"
          v-model="device.ecobeesbthermostatid"
          :label="$t('new3.unit.thermostatID')"
          :placeholder="$t('new3.unit.thermostatID')"
          :error-message="ecobeesbthermostatidError"
          @keyup="setButtonEcobeeSB")

        .ecobeeSBStatus__button
          button.van-button.van-button--primary(
            @click='setEcobeeSBParams'
          )
            span(v-if="!textButtonEcobeeSB")
              | {{ $t('new3.unit.set') }}
            span(v-if="textButtonEcobeeSB")
              | {{ $t('new3.unit.check') }}

      van-switch-cell(
        v-if='device.pelican !== undefined',
        v-model='pelican',
        :title='$t("new3.unit.pelican")',
        @change="setPelican(pelican)"
      )

      van-cell-group.addUnit__popup__cell-group.home__title(
        v-if="pelican"
      )

        van-field(
          border=false
          input-align="right"
          v-model="device.pelicansite"
          :label="$t('new3.unit.pelicansite')"
          :placeholder="$t('new3.unit.pelicansite')"
          :error-message="pelicansiteError"
          @keyup="setButtonPelican")

        van-field(
          type="email"
          v-model="device.pelicanemail"
          :label="$t('auth.form.email')"
          :placeholder="$t('auth.form.email')"
          :error-message="pelicanemailError"
          @keyup="setButtonPelican")

        van-field(
          border=false
          input-align="right"
          v-model="device.pelicanpass"
          :label="$t('auth.form.password')"
          :placeholder="$t('auth.form.password')"
          :error-message="pelicanpassError"
          @keyup="setButtonPelican")

        van-field(
          border=false
          input-align="right"
          v-model="device.pelicanserial"
          :label="$t('new3.unit.pelicanserial')"
          :placeholder="$t('new3.unit.pelicanserial')"
          :error-message="pelicanserialError"
          @keyup="setButtonPelican")

        .ecobeeSBStatus__button
          button.van-button.van-button--primary(
            @click='setPelicanParams'
          )
            span(v-if="!textButtonPelican")
              | {{ $t('new3.unit.set') }}
            span(v-if="textButtonPelican")
              | {{ $t('new3.unit.check') }}

</template>

<script>
import { sanitizeWebserver } from '@/models/webserver.model';
import BluetoothService from '@/services/bluetooth.service';
import { getErrorId } from '@/services/error.service';
import mapTranslations from '@/utils/mapTranslations';

export default {
  props: {
    device: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      lapi: this.device.lapi === 1,
      venstar: this.device.venstar === 1,
      pelican: this.device.pelican === 1,
      ecobeesb: this.device.ecobeesb === 1,
      textButtonEcobeeSB: null,
      textButtonPelican: null,
      pelicansiteError: null,
      pelicanemailError: null,
      pelicanpassError: null,
      pelicanserialError: null,
      ecobeesbclientidError: null,
      ecobeesbclientsecretError: null,
      ecobeesbthermostatidError: null,
      output: '',
      outputOptions: [],
      // this.device.rs485_availablemodes !== undefined ? this.getOutputOptions() : [],
      comRS485MapTranslation: mapTranslations.RS485_AVAILABLEMODES,
      modbusaddr: this.device.modbusaddr || null,
      modbusspeed: this.device.modbusspeed || null,
      bacneton: null,
      bacnetmac: this.device.bacnetmac || null,
      bacnetid: this.device.bacnetid || null,
      bacnetmaxnum: this.device.bacnetmaxnum || null,
      bacnetspeed: this.device.bacnetspeed || null,
      bacnetmaxframes: this.device.bacnetmaxframes || null,
      speeds: [300, 600, 1200, 2400, 4800, 9600, 19200, 38400, 57600, 76800, 115200],
      isLoading: false,
      modbusaddrError: null,
      bacnetmacError: null,
      bacnetidError: null,
      bacnetmaxnumError: null,
      bacnetmaxframesError: null,
    };
  },

  computed: {
    arraySpeeds() {
      return this.speeds.map(item => {
        return { description: `${item}` };
      });
    },
  },

  methods: {
    /**
     * Guarda valor seleccionado del servicio
     * @param {String} service - Nombre del servicio
     * @param {Integer} value - Valor de la activación del servicio especificado
     */
    async saveWsService(service, value) {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Inicializo valores
        this.isLoading = true;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        // Preparo los datos
        const data = {};

        data[service] = +value;

        // Realizo la petición
        const dataResult = await BluetoothService.setWsService(this.device.id, data);

        this.device[service] = +value;

        this.$toast.clear();
        this.$toast.success({
          mask: true,
          message: this.$i18n.t('new3.unit.ok'),
        });
        console.log('result: ', dataResult);
        // this.close(dataResult.params);
      } catch (error) {
        console.log(error);
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: this.$i18n.t('new3.unit.fail') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Actualiza el valor de ecobee SmartBuildings en el device por bluetooth
     * @param {Boolean} value - Valor de la activación del EcobeeSB
     */
    async setEcobeeSB(value) {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Inicializo valores
        this.isLoading = true;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        // Preparo los datos parseando el boleano a número
        const data = {
          ecobeesb: +value,
        };
        console.log(data);

        // Realizo la petición
        const dataResult = await BluetoothService.setDeviceParam(
          this.device.id,
          JSON.stringify(data)
        );

        if (value) {
          this.device.ecobeesb = +value;
          await this.getEcobeeSBParams();
          this.checkButtonEcobeeSB();
        } else {
          await this.getEcobeeSBParams();
        }
        this.$toast.clear();
        this.$toast.success({
          mask: true,
          message: this.$i18n.t('new3.unit.ok'),
        });

        console.log('result: ', dataResult);
        // this.close(dataResult.params);
      } catch (error) {
        console.log(error);
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: this.$i18n.t('new3.unit.fail') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Actualiza los parámetros y comprueba el estado de Ecobee SmartBuildings en el device por bluetooth
     */
    async setEcobeeSBParams() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Inicializo valores
        this.ecobeesbclientidError = null;
        this.ecobeesbclientsecretError = null;
        this.ecobeesbthermostatidError = null;

        // Valido los datos
        if (this.device.ecobeesbclientid === '') {
          this.ecobeesbclientidError = this.$i18n.t('protocol.emptyInputError');
          return;
        }
        if (this.device.ecobeesbclientsecret === '') {
          this.ecobeesbclientsecretError = this.$i18n.t('protocol.emptyInputError');
          return;
        }
        if (this.device.ecobeesbthermostatid === '') {
          this.ecobeesbthermostatidError = this.$i18n.t('protocol.emptyInputError');
          return;
        }

        // Inicializo valores
        this.isLoading = true;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        const data = {};
        data.ecobeesbclientid = this.device.ecobeesbclientid;
        data.ecobeesbclientsecret = this.device.ecobeesbclientsecret;
        data.ecobeesbthermostatid = this.device.ecobeesbthermostatid;

        // Init state to show the result of ecobee SB state when is ok or fail and can be the same in this response
        this.device.ecobeesbstatus = -1;

        // Realizo la petición
        const dataResult = await BluetoothService.setDeviceParam(
          this.device.id,
          JSON.stringify(data)
        );

        // Change text to button
        this.textButtonEcobeeSB = true;

        await this.getEcobeeSBParams();
        if (this.device.ecobeesbstatus) {
          this.$toast.success({
            mask: true,
            message: this.$i18n.t('new3.unit.ok'),
          });
        } else {
          this.$toast.fail({
            mask: true,
            message: this.$i18n.t('new3.unit.fail'),
          });
        }

        console.log('result: ', dataResult);
        // this.close(dataResult.params);
      } catch (error) {
        console.log(error);
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: this.$i18n.t('new3.unit.fail') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Actualiza el valor de Pelican en el device por bluetooth
     * @param {Boolean} value - Valor de la activación del Pelican
     */
    async setPelican(value) {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Inicializo valores
        this.isLoading = true;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        // Preparo los datos parseando el boleano a número
        const data = {
          pelican: +value,
        };
        console.log(data);

        // Realizo la petición
        const dataResult = await BluetoothService.setWsService(this.device.id, data);

        if (value) {
          this.device.pelican = +value;
          await this.getPelicanParams();
          this.checkButtonPelican();
        } else {
          await this.getPelicanParams();
        }
        this.$toast.clear();
        this.$toast.success({
          mask: true,
          message: this.$i18n.t('new3.unit.ok'),
        });

        console.log('result: ', dataResult);
        // this.close(dataResult.params);
      } catch (error) {
        console.log(error);
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: this.$i18n.t('new3.unit.fail') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Actualiza los parámetros y comprueba el estado de Pelican en el device por bluetooth
     */
    async setPelicanParams() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Inicializo valores
        this.pelicansiteError = null;
        this.pelicanemailError = null;
        this.pelicanpassError = null;
        this.pelicanserialError = null;

        // Valido los datos
        if (this.device.pelicansite === '') {
          this.pelicansiteError = this.$i18n.t('protocol.emptyInputError');
          return;
        }
        if (this.device.pelicanemail === '') {
          this.pelicanemailError = this.$i18n.t('protocol.emptyInputError');
          return;
        }
        if (this.device.pelicanpass === '') {
          this.pelicanpassError = this.$i18n.t('protocol.emptyInputError');
          return;
        }
        if (this.device.pelicanserial === '') {
          this.pelicanserialError = this.$i18n.t('protocol.emptyInputError');
          return;
        }

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;

        const data = {};
        data.pelicansite = this.device.pelicansite;
        data.pelicanemail = this.device.pelicanemail;
        data.pelicanpass = this.device.pelicanpass;
        data.pelicanserial = this.device.pelicanserial;

        // Init state to show the result of pelican state when is ok or fail and can be the same in this response
        this.device.pelicanstatus = -1;

        // Realizo la petición
        const dataResult = await BluetoothService.setDeviceParam(
          this.device.id,
          JSON.stringify(data)
        );

        // Change text to button
        this.textButtonPelican = true;

        await this.getPelicanParams();
        if (this.device.pelicanstatus) {
          this.$toast.success({
            mask: true,
            message: this.$i18n.t('new3.unit.ok'),
          });
        } else {
          this.$toast.fail({
            mask: true,
            message: this.$i18n.t('new3.unit.fail'),
          });
        }

        console.log('result: ', dataResult);
        // this.close(dataResult.params);
      } catch (error) {
        console.log(error);
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: this.$i18n.t('new3.unit.fail') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Obtiene los parámetros EcobeeSB para asignarlos a los campos de formulario de la vista
     */
    async getEcobeeSBParams() {
      const ecobeeData = await BluetoothService.getDeviceParams(this.device.id, [
        'ecobeesbclientid',
        'ecobeesbclientsecret',
        'ecobeesbthermostatid',
        'ecobeesbstatus',
      ]);
      this.device.ecobeesbclientid = ecobeeData.params.ecobeesbclientid;
      this.device.ecobeesbclientsecret = ecobeeData.params.ecobeesbclientsecret;
      this.device.ecobeesbthermostatid = ecobeeData.params.ecobeesbthermostatid;
      this.device.ecobeesbstatus = ecobeeData.params.ecobeesbstatus;
    },

    /**
     * Obtiene los parámetros Pelican para asignarlos a los campos de formulario de la vista
     */
    async getPelicanParams() {
      const pelicanData = await BluetoothService.getDeviceParams(this.device.id, [
        'pelicansite',
        'pelicanemail',
        'pelicanpass',
        'pelicanserial',
        'pelicanstatus',
      ]);
      this.device.pelicansite = pelicanData.params.pelicansite;
      this.device.pelicanemail = pelicanData.params.pelicanemail;
      this.device.pelicanpass = pelicanData.params.pelicanpass;
      this.device.pelicanserial = pelicanData.params.pelicanserial;
      this.device.pelicanstatus = pelicanData.params.pelicanstatus;
    },

    /**
     * Comprueba si tiene parámetros EcobeeSB para mostrar texto del botón
     */
    checkButtonEcobeeSB() {
      this.textButtonEcobeeSB =
        this.device.ecobeesbclientid !== undefined &&
        this.device.ecobeesbclientid !== null &&
        this.device.ecobeesbclientid !== '' &&
        this.device.ecobeesbclientsecret !== undefined &&
        this.device.ecobeesbclientsecret !== null &&
        this.device.ecobeesbclientsecret !== '' &&
        this.device.ecobeesbthermostatid !== undefined &&
        this.device.ecobeesbthermostatid !== null &&
        this.device.ecobeesbthermostatid !== '';
      console.log('textButtonEcobeeSB', this.textButtonEcobeeSB);
    },

    /**
     * Cambia el texto del botón EcobeeSB a "Establecer"
     */
    setButtonEcobeeSB() {
      // Inicializo valores
      this.ecobeesbclientidError = null;
      this.ecobeesbclientsecretError = null;
      this.ecobeesbthermostatidError = null;
      this.textButtonEcobeeSB = false;
    },

    /**
     * Comprueba si tiene parámetros Pelican para mostrar texto del botón
     */
    checkButtonPelican() {
      // console.log('checkButtonPelican: ', this.hasPelicanParams);
      this.textButtonPelican =
        this.device.pelicansite !== undefined &&
        this.device.pelicansite !== null &&
        this.device.pelicansite !== '' &&
        this.device.pelicanemail !== undefined &&
        this.device.pelicanemail !== null &&
        this.device.pelicanemail !== '' &&
        this.device.pelicanpass !== undefined &&
        this.device.pelicanpass !== null &&
        this.device.pelicanpass !== '' &&
        this.device.pelicanserial !== undefined &&
        this.device.pelicanserial !== null &&
        this.device.pelicanserial !== '';
      console.log('textButtonPelican', this.textButtonPelican);
    },

    /**
     * Cambia el texto del botón Pelican a "Establecer"
     */
    setButtonPelican() {
      // Inicializo valores
      this.pelicansiteError = null;
      this.pelicanemailError = null;
      this.pelicanpassError = null;
      this.pelicanserialError = null;
      this.textButtonPelican = false;
    },

    /**
     * Muestra el selector de la salida del puerto de integración RS485
     */
    openSetOutput(value) {
      const configOutput = {
        title: this.$i18n.t('new3.unit.output'),
        items: [[this.outputOptions]],
        positiveButtonText: this.$i18n.t('fallback.done'),
        negativeButtonText: this.$i18n.t('fallback.cancel'),
        theme: 'dark',
        displayKey: 'text',
        defaultItems: {
          0: `${value}`,
        },
      };

      window.SelectorCordovaPlugin.showSelector(configOutput, result => {
        this.output = this.outputOptions[result[0].index].text;
        this.setOutput(this.outputOptions[result[0].index].value);
      });
    },

    /**
     * Actualiza el valor de la salida de integración del puerto RS485 en el device por bluetooth
     * @param {Boolean} value - Valor de la salida de integración
     */
    async setOutput(value) {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Inicializo valores
        this.isLoading = true;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        // Preparo los datos
        const data = {
          rs485_mode: value,
        };
        console.log(data);

        // Realizo la petición
        const dataResult = await BluetoothService.setDeviceParam(
          this.device.id,
          JSON.stringify(data)
        );

        await this.getRS485Params(value);
        this.device.rs485_mode = value;

        this.$toast.clear();
        this.$toast.success({
          mask: true,
          message: this.$i18n.t('new3.unit.ok'),
        });

        console.log('result: ', dataResult);
      } catch (error) {
        console.log(error);
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: this.$i18n.t('new3.unit.fail') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Pedir datos según el valor del parámetro seleccionado
     * @param {Integer} value - Valor del parámetro RS485 seleccionado
     */
    async getRS485Params(value) {
      // Pido extrainfo si no tengo información de los parámetros según el value seleccionado:
      // 0: Modbus
      // 1: Bacnet
      // 3: AirQBox
      // 2: Palladiom
      // 4: Medidores
      // 5: Termostato Airzone
      if (value === 0 || value === 1) {
        const webserver = await BluetoothService.getDeviceInfo(this.device.id);
        const device = sanitizeWebserver(this.device.id, this.device.webserverName, webserver);
        console.log('device: ', device);
        // Asigno lo valores de los campos según sea bacnet (value = 1) o modbus (value = 0)
        if (value) {
          this.device.bacnetid = device.bacnetid;
          this.device.bacnetmaxframes = device.bacnetmaxframes;
          this.device.bacneton = device.bacneton;
          this.device.bacnetmac = device.bacnetmac;
          this.device.bacnetspeed = device.bacnetspeed;
          this.device.bacnetmaxnum = device.bacnetmaxnum;
        } else {
          this.device.bacneton = false;
          this.device.modbusaddr = device.modbusaddr;
          this.device.modbusspeed = device.modbusspeed;
          this.device.modbusparity = device.modbusparity;
          this.device.modbusbitstop = device.modbusbitstop;
        }
        // } else if(value === 4){
        //   try {
        //     // Pido por BLE los datos para comprobar que se ha asignado
        //     await this.getMetersData()
        //   } catch( err ) {
        //     console.log(err)
        //   }
      }
    },

    /**
     * Devuelve el texto de la configuración de la salida del puerto de integración
     */
    getOutputText(value) {
      const option = this.outputOptions.find(item => item.value === value);
      return option.text;
    },

    /**
     * Devuelve el valor de la configuración de la salida del puerto de integración
     */
    getOutputValue(text) {
      const option = this.outputOptions.find(item => item.text === text);
      return option.value;
    },

    /**
     * Asigna las opciones de configuración de las salidas del puerto de integración
     */
    getOutputOptions() {
      for (let i = 0; i < this.device.rs485_availablemodes.length; i++) {
        this.outputOptions.push({
          value: this.device.rs485_availablemodes[i],
          text: this.comRS485MapTranslation[this.device.rs485_availablemodes[i]](),
        });
      }
    },

    /**
     * Muestra el selector de temperatura
     */
    openSetSpeed(value, protocol) {
      const configSpeed = {
        title: this.$i18n.t('protocol.selectSpeed'),
        items: [[this.arraySpeeds]],
        positiveButtonText: this.$i18n.t('protocol.done'),
        negativeButtonText: this.$i18n.t('protocol.cancel'),
        theme: 'dark',
        defaultItems: {
          0: `${value}`,
        },
      };

      window.SelectorCordovaPlugin.showSelector(configSpeed, result => {
        if (protocol === 'modbus') {
          this.modbusspeed = parseInt(result[0].description, 10);
        } else {
          this.bacnetspeed = parseInt(result[0].description, 10);
        }
        this.saveProtocol();
      });
    },

    /**
     * Guarda los datos
     */
    // eslint-disable-next-line
    async saveProtocol() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Inicializo valores
        this.modbusaddrError = null;
        this.bacnetmacError = null;
        this.bacnetidError = null;
        this.bacnetmaxnumError = null;
        this.bacnetmaxframesError = null;

        // Valido los datos
        if (
          this.device.modbusaddr !== undefined &&
          (!this.modbusaddr || this.modbusaddr < 1 || this.modbusaddr > 128)
        ) {
          this.modbusaddrError = this.$i18n.t('protocol.modbusaddrError');
          return;
        }
        if (
          this.device.bacnetmac !== undefined &&
          (!this.bacnetmac || this.bacnetmac < 1 || this.bacnetmac > 127)
        ) {
          this.bacnetmacError = this.$i18n.t('protocol.bacnetmacError');
          return;
        }
        if (
          this.device.bacnetid !== undefined &&
          (!this.bacnetid || this.bacnetid < 1 || this.bacnetid > 4194303)
        ) {
          this.bacnetidError = this.$i18n.t('protocol.bacnetidError');
          return;
        }
        if (
          this.device.bacnetmaxnum !== undefined &&
          (!this.bacnetmaxnum || this.bacnetmaxnum < 1 || this.bacnetmaxnum > 127)
        ) {
          this.bacnetmaxnumError = this.$i18n.t('protocol.bacnetmaxnumError');
          return;
        }
        if (
          this.device.bacnetmaxframes !== undefined &&
          (!this.bacnetmaxframes || this.bacnetmaxframes < 1 || this.bacnetmaxframes > 127)
        ) {
          this.bacnetmaxframesError = this.$i18n.t('protocol.bacnetmaxframesError');
          return;
        }

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;

        // Preparo los datos
        const data = {};

        if (this.bacneton !== null) data.bacneton = this.bacneton ? 1 : 0;
        if (this.bacnetmac !== null) data.bacnetmac = parseInt(this.bacnetmac, 10);
        if (this.bacnetid !== null) data.bacnetid = parseInt(this.bacnetid, 10);
        if (this.bacnetmaxnum !== null) data.bacnetmaxnum = parseInt(this.bacnetmaxnum, 10);
        if (this.bacnetspeed !== null) data.bacnetspeed = parseInt(this.bacnetspeed, 10);
        if (this.bacnetmaxframes !== null)
          data.bacnetmaxframes = parseInt(this.bacnetmaxframes, 10);
        if (this.modbusaddr !== null) data.modbusaddr = parseInt(this.modbusaddr, 10);
        if (this.modbusspeed !== null) data.modbusspeed = parseInt(this.modbusspeed, 10);

        // Realizo la petición
        await BluetoothService.setExtrainfo(this.device.id, JSON.stringify(data));
        const webserver = await BluetoothService.getDeviceInfo(this.device.id);
        const device = sanitizeWebserver(this.device.id, this.device.webserverName, webserver);
        console.log('device: ', device);
        this.device.bacneton = device.bacneton;
        this.device.bacnetmac = device.bacnetmac;
        this.device.bacnetid = device.bacnetid;
        this.device.bacnetmaxnum = device.bacnetmaxnum;
        this.device.bacnetspeed = device.bacnetspeed;
        this.device.bacnetmaxframes = device.bacnetmaxframes;
        this.device.modbusaddr = device.modbusaddr;
        this.device.modbusspeed = device.modbusspeed;

        this.$toast.clear();
        this.$toast.success({
          mask: true,
          message: this.$i18n.t('new3.unit.ok'),
        });
      } catch (error) {
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: this.$i18n.t('new3.unit.fail') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Cierra este componente
     */
    close() {
      this.$emit('close', this.device);
    },
  },

  created() {
    console.log('this: ', this);
    // Comprobamos si tiene parámetros EcobeeSB para mostrar texto del botón
    this.checkButtonEcobeeSB();

    // Comprobamos si tiene parámetros Pelican para mostrar texto del botón
    this.checkButtonPelican();

    // Inicializo el estado para que no se muestre al entrar
    this.device.ecobeesbstatus = -1;
    console.log(' ============ device ============', this.device);

    // Inicializo la salida en el puerto de integración y sus opciones si existen
    if (this.device.rs485_mode !== undefined && this.device.rs485_availablemodes !== undefined) {
      this.getOutputOptions();
      this.output = this.getOutputText(this.device.rs485_mode);
    }
  },
};
</script>
